import { Fragment, useState } from "react";
import Config from "../../../Config";
import Calendar from "../../../calendar/Calendar";
import InputCombo from "../../../helpers/InputCombo";
import MenuTable from "../../../helpers/MenuTable";
import InputComboMiesiac from "../../../helpers/InputComboMiesiac";
import InputComboRok from "../../../helpers/InputComboRok";
import InputLegend from "../../../helpers/InputLegend";


function Free(props)
{
    
     
    const [errTab, setErrTab] = useState([]);  //z info od serwera..

    const [row,setRow] = useState({
        dzien: '',
    });

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);
    const [tab, setTab] = useState(null);



    var dt = new Date();

    var strM = (dt.getMonth()+1)+"";
    if(strM.length == 1) strM = "0" + strM;
 
    var strD = dt.getDate()+"";
    if(strD.length == 1) strD = "0" + strD;
 
    //var dateX  = dt.getFullYear()+"-"+strM+"-"+strD;


    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({   
                 
 
        rok: dt.getFullYear(),
        miesiac: strM,
 
        limit: 50,
        page: 1,
        pages: 1,
    });



    const [itemSelected, setItemSelected] = useState(2);
    const clickTab = (e) => {
 
        var t = e.target.getAttribute("atr-tab");
        setItemSelected(t);
    }


    const [daysSelected, setDaysSelected] = useState([]);
  
    const getData = () => {


        props.mainView.setProgress(-2);
 

        fetch( Config.url + '/rest_v1_parents,get_free', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);                                                                                         
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
               



    }




    const onMonthChange = (y,m) => {

        var rok = y;
        var miesiac =  m+"";
        if(miesiac.length < 2) miesiac = "0" + miesiac;
  
        var nData = rok + "-" + miesiac + "-01";     
      // setRow({...row, ["dzien"]: '', ["p_grupa_id"]:'_x_'  }); 
     }
  
   
     const clickOnDay = (date,title) => {      
        

        if( tab != null && tab.stawki != null && tab.stawki.length < 1 )
        {
                        props.mainView.showDialog("Ups!", "Nie możesz zgłosić nieobecności. Brak przypisanej stawki dziennej do umowy dziecka." ,  "ok"  , (param) => {                            
                        } ); 
                        return;
        }


     
        if( date != null && date.length > 2)
        {           
            //setRow({...row, ["dzien"]: date, ["p_grupa_id"]:'_x_'  });       
            //setRow({...row, ["dzien"]: date  });       

            //sprawdz czy juz dodało wczesniej..
            var isAdded = false;
            var newArray = new Array();


            for(var k=0; k<daysSelected.length; k++)
            {
                if(daysSelected[k].dzien == date) {isAdded = true;  continue; }

                newArray.push(daysSelected[k]);
            }


            if(!isAdded)
            {
                var js = JSON.parse( JSON.stringify(daysSelected) );
                js.push( {
                    dzien: date
                });
    
                setDaysSelected(js);
            }   else
            {
              setDaysSelected(newArray);
            }         

        }
      
  
    }

    const clearDays = () => {

        setDaysSelected([]);  

    }
    


    const valChangeListenerFilter = (filedName, val, correct, msg) => {

       
        setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );       
        setTab(null);
    }


    const valChangeListener = (filedName, val, correct, msg) => {

        //"inx-" + ix

        var sp = filedName.split("-");
        var inx =  parseInt(sp[1]);

        var stawki = JSON.parse(JSON.stringify(tab.stawki) );
        stawki[inx]["status"] = val;

        setTab({...tab, ["stawki"]:stawki });

    }

    const goNextNew = () => {
      
    }


    const saveOne = () => {
      
        if(tab.stawki.length > 0)
        {
            tab.stawki[0].status = "2";
        }


        props.mainView.showDialog("Potwierdź", "Na pewno chcesz wysłać zgłoszenie?" ,  "yesno"  , (param) => {

            if(param == "yes")
            {
                sendNotcie();
            }

        } ); 

        
    }

    const save = () => {


        props.mainView.showDialog("Potwierdź", "Na pewno chcesz wysłać zgłoszenie?" ,  "yesno"  , (param) => {

            if(param == "yes")
            {
                sendNotcie();
            }

        } ); 
    }



    const sendNotcie = () => {

        console.log(tab.stawki);

        if(daysSelected.length < 1)
        {
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , "Wybierz dni z kalendarza" ,  "ok"  ,null); 
            return;
        }


        var isSelected = false;

        for(var k=0; k<tab.stawki.length; k++)
        {
           if(tab.stawki[k].status != undefined && tab.stawki[k].status != '_x_') 
           {
                isSelected = true;
           }
        }

        
        if(isSelected == false)
        {
                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , "Zmień status obecności min. na jednym wybranym posiłku." ,  "ok"  ,null); 
                return;
        }


        var req = {
            dni: daysSelected,
            stawki: tab.stawki,
        };

       

        props.mainView.setProgress(-2);
 

        fetch( Config.url + '/rest_v1_parents,eat_update', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
        })
        .then(res => res.json() )
        .then(res => {             
                    
                    props.mainView.setProgress(-1);

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                    // props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    setErrTab(res.result);
                    }else
                    if(res.status != undefined && res.status == "OK")
                    {
                        props.mainView.showDialog( "Sukces",  "Zmiany zostały zapisane", "ok" , null);                        
                        setTab(null);
                        setDaysSelected([]);
                    }else
                    {
                        props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                    }
                
        } )
        .catch(err => {   
                    props.mainView.setProgress(-1);       
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
        });


    }


    const goDelete = (e) => 
    {        
        var id     = e.target.getAttribute("id");
        var title  = e.target.getAttribute("title");

        props.mainView.showDialog('Potwierdź' , "Na pewno chcesz usunąć zgłoszoną nieobecność (" + title + ") ?" ,  "yesno"  , (param) => {


                        if(param != "yes") return;

                        
                        props.mainView.setProgress(-2);
                        
                        var req  = {
                            id: id,
                        };

                                fetch( Config.url + '/rest_v1_parents,eat_cancel', {
                                    method: 'POST', 
                                    body: JSON.stringify(req), 
                                    headers: {
                                        'Content-Type': 'application/json',                    
                                        'X-Api-Key': props.userData.apiKey,
                                        '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                                        '_p_dziecko_id_': props.userData.p_dziecko_id,
                                        '_sec_key_': Config.genXKey() ,
                                    }
                                })
                                .then(res => res.json() )
                                .then(res => {             
                                            
                                            props.mainView.setProgress(-1);

                                            if(res._sys_ == undefined)
                                            {
                                                props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                                            }else
                                            if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                            {
                                            // props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                                            setErrTab(res.result);
                                            }else
                                            if(res.status != undefined && res.status == "OK")
                                            {
                                                props.mainView.showDialog( "Sukces",  "Zgłoszenie zostało anulowane", "ok" , null);                        
                                                setTab(null);
                                                setDaysSelected([]);
                                            }else
                                            {
                                                props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                                            }
                                        
                                } )
                                .catch(err => {   
                                            props.mainView.setProgress(-1);       
                                            props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                                });

        } ); 

    }


    const filterApprove = () => {   
        setTab(null)     
    }


    const filterClear = () => {
        setFilterParam({     
            rok: (new Date()).getFullYear() ,
            miesiac: (new Date() ).getMonth()+1,            
            sortBy: {
                sort:  "", //asc desc,
                column: "",
            },
        });
        setTab(null);
 
    }


    
 const [legend, setLegend] = useState([
    {
        cls:'color_show_nb_w_czasie',
        title: 'Nieobecny ',
   
    },
    {
        cls:'color_show_nb_po_czasie',
        title: 'Nieboecny (zgł. po czasie)',
   
    },
]);





    if(tab == null)
        {
            setTab([]);
            getData();      
            return (
                <div></div>
            );        
        }


    
    if(refreshView != props.userData.refreshView)
    {         
          setRefreshView( props.userData.refreshView);
          setTab(null);
    }    



    
   var daysReview = new Array();
   var strDays = "";

   for(var k=0; k < daysSelected.length; k++)
   {
        daysReview.push({
        date:  daysSelected[k].dzien,
        title: "wybrano " +  daysSelected[k].dzien,
        className: "selected",
        });

        strDays = strDays + "  " +  daysSelected[k].dzien;
   }

   


   var tabLp = 0;



   
   var itemsOb = [
    { v: '2', title: "Dziecko będzie nieobecne" },
    { v: '1', title: "Dziecko będzie obecne" },
    { v: '_x_', title: "Pozostaw bez zmian" },
];



var cssTab1 = "";
var cssTab2 = "";


if(itemSelected == 1) cssTab1 = " xActive ";
if(itemSelected == 2) cssTab2 = " xActive ";


  //-----------------------------------------------------------------------------
   //-----------------------------------------------------------------------------

   const onClickFree = (e) => {        

    var gTitle    =  e.target.getAttribute("atr-title"); 

    props.mainView.showDialog("eLizak", gTitle , "ok", (option)=>{
      
        ///--------
  
        //--------
        } );

}

const onClickTime = (e) => {

    //    atr-id={grf.id} atr-date={px.date} atr-start={grf.od} atr-end={grf.do}  atr-title={tt.nazwisko + " " + tt.imie + " " + px.date } onClick={onClickTime} 

       var gId       =  e.target.getAttribute("atr-id"); 
       var gDay      =  e.target.getAttribute("atr-date"); 
       var gStart    =  e.target.getAttribute("atr-start"); 
       var gEnd      =  e.target.getAttribute("atr-end"); 
       var gTitle    =  e.target.getAttribute("atr-title"); 

     //  alert(gId + " " + gTitle + " | " + gStart + " | " + gEnd);


       props.mainView.showDialog("eLizak", gTitle + " ("+gStart+" / "+gEnd+") ", "ok", (option)=>{
      
        ///--------
  
        //--------
        } );

}


 

 var rok      = filterParam.rok;
 var miesiac = filterParam.miesiac;
 
 var d = new Date( rok  ,   miesiac , 0);
 var lastDay = d.getDate();

 d = new Date( rok  ,   miesiac-1 , 1);
 var dayWeek =  d.getDay();



 
 var calD = [
     [' ',' ',' ',' ',' ',' ',' '],
     [' ',' ',' ',' ',' ',' ',' '],
     [' ',' ',' ',' ',' ',' ',' '],
     [' ',' ',' ',' ',' ',' ',' '],
     [' ',' ',' ',' ',' ',' ',' '],
     [' ',' ',' ',' ',' ',' ',' '],
 ];

 var dayX = 0;



 for(var rowInx=0; rowInx<calD.length; rowInx++)
 {
     for(var dd=0; dd<7; dd++)
     {
         if(dayX > lastDay) break;
         if(dd == 0 && dayWeek ==1 && dayX==0 ) {dayX = 1;}else
         if(dd == 1 && dayWeek ==2 && dayX==0 ) {dayX = 1;}else
         if(dd == 2 && dayWeek ==3 && dayX==0 ) {dayX = 1;}else
         if(dd == 3 && dayWeek ==4 && dayX==0 ) {dayX = 1;}else
         if(dd == 4 && dayWeek ==5 && dayX==0 ) {dayX = 1;}else
         if(dd == 5 && dayWeek ==6 && dayX==0 ) {dayX = 1;}else 
         if(dd == 6 && dayWeek ==0 && dayX==0 ) {dayX = 1;}else {}

         
         
         if(dayX == 0)
         {
             calD[rowInx][dd] = {
                 date: '',
                 day: '',
                 title: '',
                 dw: '',
                 rows: new Array(),
             }; 
         }else
         {

             var strM = miesiac+"";
             if(strM.length == 1) strM = "0" + strM;

             var strD = dayX+"";
             if(strD.length == 1) strD = "0" + strD;

             var dateX  = rok+"-"+strM+"-"+strD;             
       
             var p = new Array();

           

         
   
            if( tab != null && tab.dni != null )
            {                  
                    if( tab.dni[dateX]  != undefined )
                    {
                         p.push( tab.dni[dateX]  ) ;    
                         //console.log( tab.dni[dateX]  ); 
                         //break;
                    }                
            }
            
 



             calD[rowInx][dd] = {
                 date: dateX,
                 day: dayX,
                 title: 'Pokaż',
                 dw: dd,
                 className: "",
                 rows: p,
             }; 
         }

         if(dayX>0)
         dayX++;
     }
 }

 if(calD[5][0] == ' ') {
     calD = calD.slice(0, -1);
 }


 var monthName = "";
 if(filterParam.miesiac == 1) monthName = "Styczeń";
 if(filterParam.miesiac == 2) monthName = "Luty";
 if(filterParam.miesiac == 3) monthName = "Marzec";
 if(filterParam.miesiac == 4) monthName = "Kwiecień";
 if(filterParam.miesiac == 5) monthName = "Maj";
 if(filterParam.miesiac == 6) monthName = "Czerwiec";
 if(filterParam.miesiac == 7) monthName = "Lipiec";
 if(filterParam.miesiac == 8) monthName = "Sierpień";
 if(filterParam.miesiac == 9) monthName = "Wrzesień";
 if(filterParam.miesiac == 10) monthName = "Październik";
 if(filterParam.miesiac == 11) monthName = "Listopad";
 if(filterParam.miesiac == 12) monthName = "Grudzień";


 //-----------------------------------------------------------------------------
 //-----------------------------------------------------------------------------




 //-----------------------------------------------------------------------------

   
    
      

    return (
        <div>                                
                <br/>
                    <div>
                          {
                            tab.termin_zgloszenia_nieobecnosci == 1 &&
                            <span>Nieobeności dziecka należy zgłaszać <b>dzień wcześniej</b> do godziny: <b>{tab.godzina_zgloszenia_nieobecnosci}</b> </span>
                          }

                          {
                            tab.termin_zgloszenia_nieobecnosci == 2 &&
                            <span>Nieobeności dziecka należy zgłaszać najpóźniej <b>w dniu nieobecności</b> do godziny: <b>{tab.godzina_zgloszenia_nieobecnosci}</b> </span>
                          }

                          <div>Nieobecności zgłoszone po wyznaczonym czasie mogą być traktowane jako "dziecko obecne" - kwota za posiłki może zostać naliczona. </div>

                    </div>
                <br/>

                 <div className="block50">
                        <Calendar tab={daysReview} clickOnDay={clickOnDay} onMonthChange={onMonthChange} />
                 </div>

                 <div className="block50 gocentermobile">

                            {
                                daysSelected.length == 0 &&
                                <Fragment>
                                    <div className="big_msg">                                       
                                        Wybierz min. jeden dzień z kalendarza by zgłosić nieobecność.
                                    </div>
                                </Fragment>
                            }

                            {
                                daysSelected.length > 0 &&
                                <Fragment>

                                    <div className="calColor"> Wybrano dni {daysSelected.length}:<br/> {strDays}</div>   

                                    <br/>
                                        <a href="#" onClick={clearDays} className="link_bad"> cofnij zaznaczenie  ({daysSelected.length}) </a>
                                    <br/>
                                    <br/>


                                    {
                                        tab.stawki != undefined &&  tab.stawki.length == 1 &&
                                        <Fragment>
                                            <br/>
                                                <a href="#" onClick={saveOne} className="btn">Zgłoś nieobcność na wybrane dni ({daysSelected.length})</a>
                                        </Fragment>
                                    }   

                                    {
                                        tab.stawki != undefined && tab.stawki.length > 1 &&
                                        <Fragment>
                                                
                                                <form className="eForm bg_center">

                                                    {
                                                        tab.stawki != undefined &&
                                                        <Fragment>
                                                                {
                                                                    tab.stawki.map( (item, ix) => {
                                                                        return   <div className="form_control">
                                                                                    <div className="fieldName">{item.godzina_posilku}  {item.nazwa}</div>
                                                                                    <InputCombo mainView={props.mainView}   userData={props.userData} items={itemsOb} value={item.status} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"inx-" + ix} placeholder={":"} className='  ' req='0'   />                                                                
                                                                                </div>
                                                                    } )
                                                                }
                                                        </Fragment>
                                                    }
                                                   

                                         

                                              
                                                <div className="form_split"></div>

                                                <div className="form_btn">
                                                            <a href="#"  className="btn" onClick={save} >Wyślij informacje do placówki</a>
                                                </div>
                                             

                                                </form>
                                        </Fragment>
                                    }   
                                    

                                </Fragment>
                            }
                                                      
                 </div>

                 

                 <div className="bg_center">
                        <div className="calColor"> Zgłoszone nieobecności: </div>  
                        <br/> 


                        <div className="xTabs">
                                             <div className={"xItem " + cssTab2 } atr-tab="2" onClick={clickTab}  >Lista</div>   
                                             <div className={"xItem " + cssTab1 } atr-tab="1" onClick={clickTab}  >Kalendarz</div>                                                                         
                                             <div className={"xEmpty "  }>&nbsp;</div>
                        </div>

                        <div>
                               <br/>&nbsp;<br/>
                        </div>

                        {
                            itemSelected == 2 &&
                            <Fragment>


                                <div className="table_widget">
                                         <InputLegend items={legend} />
                                </div>

                                <div className="table_filter">

                                        <div className="filter_controll">   
                                                <label>Rok: </label>                             
                                                <InputComboRok   userData={props.userData}  mainView={props.mainView}  value={filterParam.rok}   valChange={valChangeListenerFilter} goNext={goNextNew} name="rok" placeholder={": "}  noempty="1"   />
                                        </div> 
                        
                                        <div className="filter_controll">   
                                                <label>Miesiąc: </label>                             
                                                <InputComboMiesiac   userData={props.userData}  mainView={props.mainView}  value={filterParam.miesiac}   valChange={valChangeListenerFilter} goNext={goNextNew} name="miesiac" placeholder={": "}  noempty="1"   />
                                        </div>


                                        <div className="filter_btn">                                                     
                                                    <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                                        </div>

                                </div>


                                            <div className="scorll_x">



                                            <table className="table"  >
                                                    <thead>
                                                                <tr className="header">
                                                                    <td className="td_left gocenter">LP</td>
                                                                    <td className="gocenter">Dzień</td>                                                                                      
                                                                    <td>Szczegóły / Posiłki</td>                                                                                                                                       
                                                                    <td className="td_right">Kto zgłosił</td>
                                                                    <td className="td_option"> </td>                                                   
                                                                </tr>
                                                    </thead>
                                                    <tbody>

                                                    {
                                                                tab.dni != undefined &&
                                                                <Fragment>

                                                                    {                                                             
                                                                        Object.entries(tab.dni).map(  ([key, val])  => {

                                                                            tabLp++;

                                                                            var rowStyle = " row ";
                                                                            if(tabLp % 2 == 0 )rowStyle = " row2 ";

                                                                            return <Fragment>
                                                                                        <tr className={rowStyle}>
                                                                                            <td className="gocenter">{tabLp}</td>
                                                                                            <td className="gocenter calColor min_width100px">{key}</td>
                                                                                            <td colSpan={2} className="min_width200px">
                                                                                            
                                                                                                <table className="table" >
                                                                                                    {
                                                                                                        val.map( (item, ixn) => { 


                                                                                                            var clsX = "";
                                                                                                            
                                                                                                            if(item.zgloszony_po_czasie == 1)
                                                                                                            {
                                                                                                                clsX = "color_show_nb_po_czasie";
                                                                                                            }else 
                                                                                                            {
                                                                                                                clsX ="color_show_nb_w_czasie";
                                                                                                            }

                                                                                                            return <tr>
                                                                                                                <td className="w300">                                                                                                                     
                                                                                                                    <span className={clsX}>&nbsp;&nbsp;</span>  {item.stawka.nazwa} 
                                                                                                                </td>
                                                                                                                <td>{item.zglosil.imie + " " + item.zglosil.nazwisko}</td>

                                                                                                                {
                                                                                                                    item.moze_anulowac == 1 &&
                                                                                                                    <MenuTable>
                                                                                                                    <ul>                                                                                                                
                                                                                                                        <li onClick={goDelete}  id={item.id} title={key + ", " + item.stawka.nazwa } >usuń zgł. nieobecność</li>
                                                                                                                    </ul>
                                                                                                                    </MenuTable>
                                                                                                                }

                                                                                                                {
                                                                                                                    item.moze_anulowac != 1 &&
                                                                                                                    <td> &nbsp; </td>
                                                                                                                }
                                                                                                            </tr>

                                                                                                        } )
                                                                                                    }
                                                                                                </table> 
                                                                                            
                                                                                            </td>                                                                                    
                                                                                        </tr>

                                                                                    
                                                                            </Fragment>                                                                   
                                                                        })
                                                                    }                                                               

                                                                </Fragment>
                                                    }

                                                    </tbody>
                                            </table>




                                            </div>

                            </Fragment>
                        }


                        {
                            itemSelected == 1 &&
                            <Fragment>


                                    <div className="table_widget">
                                         <InputLegend items={legend} />
                                    </div>

                                        <div className="table_filter">

                                            <div className="filter_controll">   
                                                    <label>Rok: </label>                             
                                                    <InputComboRok   userData={props.userData}  mainView={props.mainView}  value={filterParam.rok}   valChange={valChangeListenerFilter} goNext={goNextNew} name="rok" placeholder={": "}  noempty="1"   />
                                            </div> 

                                            <div className="filter_controll">   
                                                    <label>Miesiąc: </label>                             
                                                    <InputComboMiesiac   userData={props.userData}  mainView={props.mainView}  value={filterParam.miesiac}   valChange={valChangeListenerFilter} goNext={goNextNew} name="miesiac" placeholder={": "}  noempty="1"   />
                                            </div>


                                            <div className="filter_btn">                                                     
                                                    <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                                            </div>

                                        </div>


                                    
                                        
                                                                 <div className="scorll_x">
                                        
                                                                                           <div className="calSchedule "  >
                                                                                                                               <table className="schedTab" >                                       
                                                                                                                                  <tr className="days">                                                                                           
                                                                                                                                     <td className="gocenter">PN</td>
                                                                                                                                     <td className="gocenter">WT</td>
                                                                                                                                     <td className="gocenter">ŚR</td>
                                                                                                                                     <td className="gocenter">CZ</td>
                                                                                                                                     <td className="gocenter">PT</td>
                                                                                                                                     <td className="gocenter">SB</td>
                                                                                                                                     <td className="gocenter">ND</td>
                                                                                                                                  </tr>
                                        
                                                                                                                                  {
                                                                                                                                     calD.map( (week, ixWeek) => {
                                                                                                                                           return (
                                                                                                                                                 <tr className="dinside">
                                        
                                                                                                                                                       
                                                                                                                                                          {
                                                                                                                                                             week.map( (px, inxDay) => {
                                        
                                        
                                                                                                                                                                   var classTD = "";
                                        
                                                                                                                                                                   //if(px.dw == 5 || px.dw== 6) classTD = " cweek "
                                                                                                                                                                   //if(px.dw == 5 || px.dw== 6 || inxDay == 6 || inxDay == 5) classTD = " cweek gohide"
                                                                                                                                                                   if(px.dw == 5 || px.dw== 6 || inxDay == 6 || inxDay == 5) classTD = " cweek  "
                                        
                                                                                                                                                                   classTD = classTD + " " + px.className;
                                        
                                                                                                                                                                   return (                                                                            
                                                                                                                                                                      <td className={"clink w7day  " + classTD}  >
                                                                                                                                                                         <div className="tdr" title={px.title} date={px.date} onClick={clickOnDay}>
                                                                                                                                                                         <b>{px.day}</b>&nbsp;                                                                                                                                       
                                                                                                                                                                         </div>
                                                                                           
                                                                                                                                                                          <div>                                                                                                                                                                                                                     
                                                                                                                                                                            {
                                                                                                                                                                                px.rows != undefined &&
                                                                                                                                                                                <Fragment>
                                                                                                                                                                                    {
                                                                                                                                                                                              px.rows.map( (item, inx) => {
                                                                                                                                                                                                return <div>
                                                                                                                                                                                                         &nbsp;<br/>
                                                                                                                                                                                                        {

                                                                                                                                                                                                                                                                                                                                                                                                                       
                                                                                                                                                                                                            
                                                                                                                                                                                                            item.map(  (st, stInx) => {

                                                                                                                                                                                                                var clsX = "";
                                                                                                                                                                                                            
                                                                                                                                                                                                                if(st.zgloszony_po_czasie == 1)
                                                                                                                                                                                                                {
                                                                                                                                                                                                                    clsX = "color_show_nb_po_czasie";
                                                                                                                                                                                                                }else 
                                                                                                                                                                                                                {
                                                                                                                                                                                                                    clsX ="color_show_nb_w_czasie";
                                                                                                                                                                                                                }

                                                                                                                                                                                                                return <div>
                                                                                                                                                                                                                  <span className={clsX}>&nbsp;&nbsp;</span>    {st.stawka.nazwa}
                                                                                                                                                                                                                </div>
                                                                                                                                                                                                            } )
                                                                                                                                                                                                        }
                                                                                                                                                                                                </div>
                                                                                                                                                                                            } )
                                                                                                                                                                                    }
                                                                                                                                                                                </Fragment>
                                                                                                                                                                              
                                                                                                                                                                            }
                                                                                                                                                                         </div>  
                                                                                                                                                                        
                                        
                                                                                                                                                                      </td>
                                                                                                                                                                   )
                                                                                                                                                             } )
                                                                                                                                                          }
                                                                                                                                                 </tr>
                                                                                                                                           )
                                                                                                                                     } )
                                                                                                                                  }
                                        
                                                                                                                               </table>
                                                                                                                         </div>
                                        
                                                                                  </div>

                                
                            </Fragment>
                        }


                       
                 </div>
        </div>
    )
}


export default Free;